"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isSubUrlOf_1 = __importDefault(require("./isSubUrlOf"));
// Expects an array of paths that are blacklisted. Example:
// isUrlBlacklisted(url, ['/developer/']);
var isUrlBlacklisted = function (url, blacklistedRoutePrefixes) {
    return blacklistedRoutePrefixes.some(function (path) { return isSubUrlOf_1.default(url, path); });
};
exports.default = isUrlBlacklisted;
